import {Store} from "../../model/store/Store";

/**
 * ストアを取得する.
 * ユニテでモックるために分離している
 */
export let getStore = () => Store;